import { StopTypes } from 'types/Appointment';

export const SHIPLIFY_STOP_TYPES = [
  StopTypes.Pickup,
  StopTypes.Dropoff,
] as const;

export const SHIPLIFY_LOCATION_TYPE_LABELS: Record<string, string> = {
  commercial: 'Commercial',
  residential: 'Residential',
  'private-residence': 'Private residence',
  'apartment-condo': 'Apartment / condo',
  'grocery-warehouse': 'Grocery warehouse',
  'self-storage-warehouse': 'Self-storage warehouse',
};

export const SHIPLIFY_REQUIRED_ADDRESS_FIELDS = [
  ['addressLine1', 'street address'],
  ['city', 'city'],
  ['state', 'state'],
  ['zip', 'postal code'],
  ['country', 'country'],
] as const;

export const SHIPLIFY_CODE_NAME_TERMS: Record<string, string[]> = {
  RES: ['residential'],
  LIM: ['limited access'],
  GROC: ['grocery warehouse'],
};

export const SHIPLIFY_CODE_LABELS: Record<string, string> = {
  RES: 'Residential location',
  LIM: 'Limited access',
  GROC: 'Grocery warehouse',
};

export const SHIPLIFY_CONFIDENCE_ACCURACY: Record<string, number> = {
  A1: 99.5,
  A2: 90,
  A3: 80,
  A4: 70,
  U1: 80,
  U2: 65,
  U3: 55,
  U4: 45,
};
